import { z } from 'zod';
import { BaseResponseSchema } from '../../schemas.js';
import { TempFileAssociateResponseSchema, TempFileAssociateSchema, TempFileBulkDeleteResponseSchema, TempFileBulkDeleteSchema, TempFileBulkDownloadSchema, TempFileDetailsResponseSchema, TempFileExtendExpirationResponseSchema, TempFileExtendExpirationSchema, TempFileIdParamSchema, TempFileListQuerySchema, TempFileListResponseSchema, TempFileStatsResponseSchema, TempFileUploadFormSchema, TempFileUploadResponseSchema, TempFileUploadersResponseSchema, } from '../../temp-file-schemas.js';
/** REST contract for `insight-api/src/routes/tenant/temp-files.routes.ts`. */
export const tenantTempFilesContract = {
    list: {
        method: 'GET',
        path: '/tenant/temp-files',
        query: TempFileListQuerySchema,
        response: TempFileListResponseSchema,
        responseStyle: 'parse-response',
        queryLimitMax: 200,
        timeoutMs: 60000,
        errorMessage: 'Failed to list temp files',
    },
    getById: {
        method: 'GET',
        path: '/tenant/temp-files/:fileId',
        pathParams: TempFileIdParamSchema,
        response: TempFileDetailsResponseSchema,
        responseStyle: 'parse-response',
        timeoutMs: 60000,
        errorMessage: 'Failed to get temp file',
    },
    associate: {
        method: 'POST',
        path: '/tenant/temp-files/:fileId/associate',
        pathParams: TempFileIdParamSchema,
        body: TempFileAssociateSchema,
        response: TempFileAssociateResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to associate temp file',
    },
    remove: {
        method: 'DELETE',
        path: '/tenant/temp-files/:fileId',
        pathParams: TempFileIdParamSchema,
        response: BaseResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to delete temp file',
    },
    bulkDelete: {
        method: 'POST',
        path: '/tenant/temp-files/bulk-delete',
        body: TempFileBulkDeleteSchema,
        response: TempFileBulkDeleteResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to bulk delete temp files',
    },
    extendExpiration: {
        method: 'PATCH',
        path: '/tenant/temp-files/:fileId/extend-expiration',
        pathParams: TempFileIdParamSchema,
        body: TempFileExtendExpirationSchema,
        response: TempFileExtendExpirationResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to extend temp file expiration',
    },
    getStats: {
        method: 'GET',
        path: '/tenant/temp-files/stats',
        response: TempFileStatsResponseSchema,
        responseStyle: 'parse-response',
        timeoutMs: 60000,
        errorMessage: 'Failed to get temp file stats',
    },
    getUploaders: {
        method: 'GET',
        path: '/tenant/temp-files/uploaders',
        response: TempFileUploadersResponseSchema,
        responseStyle: 'unwrap-data',
        timeoutMs: 60000,
        errorMessage: 'Failed to get temp file uploaders',
    },
    upload: {
        method: 'POST',
        path: '/tenant/temp-files/upload',
        body: TempFileUploadFormSchema,
        bodyStyle: 'form-data',
        response: TempFileUploadResponseSchema,
        responseStyle: 'parse-response',
        timeoutMs: 120000,
        errorMessage: 'Failed to upload temp file',
    },
    bulkDownload: {
        method: 'POST',
        path: '/tenant/temp-files/bulk-download',
        body: TempFileBulkDownloadSchema,
        response: z.unknown(),
        responseStyle: 'blob',
        timeoutMs: 120000,
        errorMessage: 'Failed to download temp files',
    },
};
//# sourceMappingURL=tenant-temp-files.contract.js.map